import { create } from "zustand";

interface DebugState {
  showKeys: boolean;
  setShowKeys: (value: boolean) => void;
  initializeFromQuery: () => void;
}

export const useDebugStore = create<DebugState>((set) => ({
  showKeys: false,
  setShowKeys: (value) => set({ showKeys: value }),
  initializeFromQuery: () => {
    if (typeof window !== "undefined") {
      const param = new URLSearchParams(window.location.search).get("showKeys");
      if (param && param.toLowerCase() === "true") {
        set({ showKeys: true });
      }
    }
  },
}));
